import React from "react";

import styles from "./ContactInfo.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import DataCollector from "../../../UI/DataCollector/DataCollector";
import SubmitContactForm from "../../../partials/SubmitContactForm/SubmitContactForm";

const DEFAULT_DATA = {
  name: "",
  email: "",
  tel: "",
  message: "",
};

const ContactInfo: React.FC = () => {
  const [data, setData] = React.useState<typeof DEFAULT_DATA>(DEFAULT_DATA);

  const handleFieldChange = (fieldName: keyof typeof data) => (value: string) => {
    setData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const onFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Отправленные данные:", data);
  };

  return (
    <section>
      <div className="container">
        {<PreviousPage currentPage="Написать нам" title="Контактная информация" />}
        <h2 className="title">Написать нам</h2>
        <form onSubmit={onFormSubmit} className={styles.form}>
          <div className={styles.top}>
            <div className={styles.item}>
              <DataCollector
                mode="regular"
                name="name"
                title="Ваше имя*"
                onChange={handleFieldChange("name")}
                value={data.name}
              />
            </div>
            <div className={styles.item}>
              <DataCollector mode="email" name="email" title="Email*" onChange={handleFieldChange("email")} value={data.email} />
            </div>
          </div>
          <div className={`${styles.item} ${styles.tel}`}>
            <DataCollector
              mode="tel"
              name="tel"
              title="Телефон*"
              placeholder="+7 (999) 999-9999"
              onChange={handleFieldChange("tel")}
              value={data.tel}
            />
          </div>
          <div className={styles.item}>
            <DataCollector
              mode="message"
              name="message"
              title="Сообщение*"
              onChange={handleFieldChange("message")}
              value={data.message}
            />
          </div>
          <SubmitContactForm />
        </form>
      </div>
    </section>
  );
};

export default ContactInfo;
